// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"cd60e0bd","387":"2603cdd3","413":"ea98fe65","494":"3f533144","540":"26ff9564","608":"c98fa458","668":"dc18ba30","813":"937c0f1b","908":"5e43ee01","967":"163bcf4b","978":"92cfc27e"}[chunkId] + ".chunk.js";
};